var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("@sport1/styled-system");

var _styledComponents = require("styled-components");

var _Basic = require("../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/RefreshButton/index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var RefreshButton = function (_React$Component) {
  (0, _inherits2.default)(RefreshButton, _React$Component);

  var _super = _createSuper(RefreshButton);

  function RefreshButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RefreshButton);
    _this = _super.call(this, props);

    _this.shouldTimerStart = function () {
      var _this$props = _this.props,
          isLive = _this$props.isLive,
          isInHalfTime = _this$props.isInHalfTime;

      if (_this.autoRefreshEnabled && isLive) {
        if (isInHalfTime) {
          _this.intervalSecs = 30000;
        } else if (!_this.intervalSecs || _this.intervalSecs !== 10000) {
          _this.intervalSecs = 10000;
        }

        _this.startTimer();
      }
    };

    _this.startTimer = function () {
      _this.cancleTimer();

      _this.timer = setTimeout(_this.checkForUpdate, _this.intervalSecs);
    };

    _this.enablingButton = function (enable) {
      var _this$props2 = _this.props,
          handleRefreshButtonPosition = _this$props2.handleRefreshButtonPosition,
          enableRefreshButton = _this$props2.enableRefreshButton;

      _this.setDisplayState(enable);

      (0, _PropsHelper.executeFunctionOrUndefined)(handleRefreshButtonPosition);
      (0, _PropsHelper.executeFunctionOrUndefined)(enableRefreshButton, enable);
    };

    _this.checkForUpdate = function () {
      var refreshParameters = _this.props.refreshParameters;

      if (_this.store && typeof _this.store.updateAvailable === 'function') {
        _this.store.updateAvailable(_objectSpread(_objectSpread({}, refreshParameters), {}, {
          callback: function callback(found) {
            switch (found) {
              case 'FOUND':
                _this.enablingButton(true);

                break;

              case 'NOT_FOUND':
                _this.shouldTimerStart();

                break;

              case 'ERROR':
              default:
                _this.cancleTimer();

                _this.enableAutoRefresh(false);

                _this.enablingButton(false);

            }
          }
        }));
      }
    };

    _this.enableAutoRefresh = function (enabled) {
      _this.cancleTimer();

      if (enabled) {
        _this.autoRefreshEnabled = true;

        _this.shouldTimerStart();
      } else {
        _this.autoRefreshEnabled = false;
      }
    };

    _this.setPositionState = function (isFixed) {
      if (isFixed !== _this.state.fixed) {
        _this.setState({
          fixed: isFixed
        });
      }
    };

    _this.setDisplayState = function (isDisplayed) {
      if (isDisplayed !== _this.state.display) {
        _this.setState({
          display: isDisplayed
        });
      }
    };

    _this.setEndReached = function (endReached) {
      if (endReached === _this.state.fixed && !_this.props.isMobile) {
        _this.setState({
          fixed: !endReached
        });
      }
    };

    _this.scrollToTop = function () {
      window.scrollTo(0, 0);
    };

    _this.cancleTimer = function () {
      window.clearTimeout(_this.timer);
    };

    _this.resetButton = function () {
      _this.setState({
        display: false,
        fixed: !_this.props.isMobile
      });
    };

    _this.onPress = function () {
      var onPress = _this.props.onPress;

      _this.scrollToTop();

      _this.resetButton();

      _this.cancleTimer();

      _this.shouldTimerStart();

      (0, _PropsHelper.executeFunctionOrUndefined)(onPress);
    };

    _this.getTopDistance = function () {
      var _this$props3 = _this.props,
          isMobile = _this$props3.isMobile,
          extraOffset = _this$props3.extraOffset,
          withoutStickyHeader = _this$props3.withoutStickyHeader;
      var fixed = _this.state.fixed;

      if (isMobile) {
        if (fixed) {
          return (0, _styledSystem.themeGet)('dimensions.navigation.height', 0)(_this.props) + (extraOffset || 0) + (withoutStickyHeader ? 20 : 75);
        }

        return (0, _styledSystem.themeGet)('dimensions.navigation.height', 0)(_this.props) + (extraOffset || 0) + 20;
      }

      return undefined;
    };

    _this.state = {
      fixed: props.initialState ? props.initialState.fixed : !props.isMobile,
      display: props.initialState && props.initialState.display || false
    };
    _this.store = props.store;
    _this.intervalSecs = 10000;
    _this.autoRefreshEnabled = true;
    return _this;
  }

  (0, _createClass2.default)(RefreshButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timer = undefined;
      this.shouldTimerStart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancleTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          type = _this$props4.type,
          textStyles = _this$props4.textStyles,
          isMobile = _this$props4.isMobile;
      var _this$state = this.state,
          fixed = _this$state.fixed,
          display = _this$state.display;
      return _react.default.createElement(_Basic.View, {
        position: "absolute",
        pl: "50%",
        width: "100%",
        top: 0,
        bottom: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184,
          columnNumber: 13
        }
      }, _react.default.createElement(_Basic.View, {
        display: display ? 'flex' : 'none',
        position: fixed ? 'fixed' : 'absolute',
        zIndex: 200,
        center: true,
        style: {
          transform: "translateX(-50%)"
        },
        top: (0, _PropsHelper.getValueConditionally)(isMobile, this.getTopDistance()),
        width: 300,
        bottom: (0, _PropsHelper.getValueConditionally)(!isMobile, 25),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 185,
          columnNumber: 17
        }
      }, _react.default.createElement(_Touchable.default, {
        onPress: this.onPress,
        bg: "background.alternate",
        borderRadius: "15px",
        style: {
          boxShadow: '0px 3px rgba(0, 0, 0, 0.2)'
        },
        center: true,
        row: true,
        px: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 197,
          columnNumber: 21
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        size: "arrowSize",
        name: "arrow-front",
        color: "font.alternate",
        rotate: -90,
        mr: 2,
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 206,
          columnNumber: 25
        }
      }), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
        size: "small",
        color: "font.alternate",
        bold: true
      }, textStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 214,
          columnNumber: 25
        }
      }), (0, _i18n.default)("liveticker_button." + type)))));
    }
  }]);
  return RefreshButton;
}(_react.default.Component);

RefreshButton.propTypes = {
  type: _propTypes.default.string,
  onPress: _propTypes.default.func,
  initialState: _propTypes.default.object,
  isLive: _propTypes.default.bool,
  isInHalfTime: _propTypes.default.bool,
  refreshParameters: _propTypes.default.object,
  extraOffset: _propTypes.default.number,
  refreshFunction: _propTypes.default.func,
  isMobile: _propTypes.default.bool,
  withoutStickyHeader: _propTypes.default.bool
};
RefreshButton.defaultProps = {
  type: 'EVENT'
};

var _default = (0, _styledComponents.withTheme)(RefreshButton);

exports.default = _default;